import { RouteReuseStrategy } from '@angular/router/';
import { ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';
export class CacheRouteReuseStrategy implements RouteReuseStrategy {

    handlers: {[key: string]: DetachedRouteHandle} = {};
    eventId:any=0;

    constructor() {

    }

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        
      if (route.data.shouldDetach === 'yes') {
        return true;
      }

      return false;
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
      this.handlers[route.data.key] = handle;
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
      let previousEventId = this.eventId;
      this.eventId = route.queryParams.Id;
      return !!route.data.key && !!this.handlers[route.data.key] && (!!(route.data.key == "attendees" && this.eventId == previousEventId) || route.data.key=='event');
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
      if (!route.data.key) {
        return null;
      }
      return this.handlers[route.data.key];
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
      return future.data.key === curr.data.key;
    }
}